import { Icon, List } from '@zillow/constellation-10';
import { IconCheckmarkFilled } from '@zillow/constellation-icons';

export const CheckListItem = ({ children }: { children: React.ReactNode }) => (
  <List.Item css={{ fontSize: 'body-sm' }}>
    <Icon css={{ marginRight: '200' }}>
      <IconCheckmarkFilled />
    </Icon>
    <span>{children}</span>
  </List.Item>
);
